<template>
  <div :class="`metapic-input metapic-input-flex`" :style="`width: ${(col / 12) * 100}%;`">
    <div class="metapic-input-label">{{ label }}</div>
    <el-input
      :model-value="data"
      size="large"
      :placeholder="placeholder"
      :type="type"
      @blur="decimalFilter"
      @focus="decimalRemoveFilter"
      @input="updateData"
      @keyup.enter="$emit('enter')"
    />
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      required: true,
    },
    placeholder: {
      required: false,
      default: '',
      type: String,
    },
    type: {
      default: 'text',
      required: false,
    },
    col: {
      type: [Number, String],
      default: 12,
    },
    isDecimal: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['enter', 'update:modelValue'],
  data() {
    return {
      data: this.modelValue,
    }
  },
  methods: {
    updateData(newValue) {
      if (this.isDecimal) {
        newValue = newValue.match(/^\d+\.?\d{0,2}/)
      }
      this.data = newValue
      this.$emit('update:modelValue', newValue)
    },
    decimalFilter() {
      if (this.isDecimal && this.data) {
        this.data = parseFloat(this.data).toFixed(2)
      }
    },
    decimalRemoveFilter() {
      if (this.isDecimal && this.data) {
        const data = Math.round(this.data)
        this.data = data === this.data ? data : this.data
      }
    },
  },
}
</script>
<style scoped lang="scss">
:deep(.el-input) {
  margin: 0;

  .el-input__wrapper {
    padding: 0;
    height: 50px;
  }

  .el-input__inner {
    box-shadow: none;
  }
}
.metapic-input {
  position: relative;
}
.metapic-input-label {
  position: absolute;
  top: 8px;
  left: 12px;
  z-index: 12;
  font-size: 14px;
  line-height: 18px;
}
.metapic-input-flex {
  float: left;
  padding-right: 16px;
  margin-bottom: 20px;
}
</style>
<style>
.metapic-input .el-input .el-input__inner {
  line-height: 20px;
  font-size: 16px;
  padding: 0 12px;
  padding-top: 28px;
  padding-bottom: 8px;
  height: 56px;
}
</style>
